import {
  DEFAULT_QUERY_PARAMS,
  FRONTEND_ROUTES,
} from "@/constants/routes"
import { PermissionsRoles } from "@/definitions/enums/permissions"
import {
  getChargesLast7DaysRangeParams,
  getCommissionsLast2PaymentMonthRangeParams,
} from "@/utils/date"
import {
  Building,
  Calendar,
  Clock,
  DollarSign,
  FileUp,
  Key,
  KeyRound,
  MonitorCog,
  NotepadText,
  Play,
  ReceiptText,
  Repeat,
  Send,
  Server,
  Settings,
  TrendingUp,
  User,
  Webhook,
} from "lucide-react"

export const data = {
  firstSidebarLink: {
    href: FRONTEND_ROUTES.MAIN.route,
    icon: TrendingUp,
    tooltip: FRONTEND_ROUTES.MAIN.label,
    label: FRONTEND_ROUTES.MAIN.label,
    mainPath: "/portal",
  },
  reportsLinks: [
    {
      tooltip: FRONTEND_ROUTES.DEFAULTER.label,
      label: FRONTEND_ROUTES.DEFAULTER.label,
      url:
        FRONTEND_ROUTES.DEFAULTER.route +
        DEFAULT_QUERY_PARAMS,
      icon: ReceiptText,
      permissionRoles: [PermissionsRoles.DEFAULTERS_READ],
      mainPath: "/report/defaulters",
    },
    {
      tooltip: FRONTEND_ROUTES.COMMISSIONS.label,
      label: FRONTEND_ROUTES.COMMISSIONS.label,
      url:
        FRONTEND_ROUTES.COMMISSIONS.route +
        DEFAULT_QUERY_PARAMS +
        getCommissionsLast2PaymentMonthRangeParams(),
      icon: DollarSign,
      permissionRoles: [PermissionsRoles.COMMISSIONS_READ],
      mainPath: "/report/commissions",
    },
  ],
  sidebarLinks: [
    {
      href:
        FRONTEND_ROUTES.CHARGES.route +
        DEFAULT_QUERY_PARAMS +
        getChargesLast7DaysRangeParams(),
      icon: Repeat,
      tooltip: FRONTEND_ROUTES.CHARGES.label,
      label: FRONTEND_ROUTES.CHARGES.label,
      mainPath: "/charges",
      permissionRoles: [PermissionsRoles.DEFAULTERS_CHARGE],
    },
    {
      href:
        FRONTEND_ROUTES.EXPORTED_REPORTS.route +
        DEFAULT_QUERY_PARAMS,
      icon: NotepadText,
      tooltip: FRONTEND_ROUTES.EXPORTED_REPORTS.label,
      label: FRONTEND_ROUTES.EXPORTED_REPORTS.label,
      mainPath: "/exported-reports",
      permissionRoles: [],
    },
  ],
  sidebarSuperAdminLinks: [
    {
      href:
        FRONTEND_ROUTES.ACCESS_MANAGEMENT.route +
        DEFAULT_QUERY_PARAMS,
      icon: KeyRound,
      tooltip: FRONTEND_ROUTES.ACCESS_MANAGEMENT.label,
      label: FRONTEND_ROUTES.ACCESS_MANAGEMENT.label,
      mainPath: "/access-management",
    },
    {
      href:
        FRONTEND_ROUTES.UPLOAD.route + DEFAULT_QUERY_PARAMS,
      icon: FileUp,
      tooltip: FRONTEND_ROUTES.UPLOAD.label,
      label: FRONTEND_ROUTES.UPLOAD.label,
      mainPath: "/upload",
    },
    {
      href: FRONTEND_ROUTES.TRANSFER_SCHEDULE.route,
      icon: Calendar,
      tooltip: FRONTEND_ROUTES.TRANSFER_SCHEDULE.label,
      label: FRONTEND_ROUTES.TRANSFER_SCHEDULE.label,
      mainPath: "/transfer-schedule",
    },
    {
      href:
        FRONTEND_ROUTES.CUSTOMERS.route +
        DEFAULT_QUERY_PARAMS,
      icon: User,
      tooltip: FRONTEND_ROUTES.CUSTOMERS.label,
      label: FRONTEND_ROUTES.CUSTOMERS.label,
      mainPath: "/customers",
    },
    {
      href:
        FRONTEND_ROUTES.BROKERS.route +
        DEFAULT_QUERY_PARAMS,
      icon: Building,
      tooltip: FRONTEND_ROUTES.BROKERS.label,
      label: FRONTEND_ROUTES.BROKERS.label,
      mainPath: "/brokers",
    },
    {
      href: FRONTEND_ROUTES.BROKER_DELIVERY_DASHBOARD.route,
      icon: Send,
      tooltip:
        FRONTEND_ROUTES.BROKER_DELIVERY_DASHBOARD.label,
      label:
        FRONTEND_ROUTES.BROKER_DELIVERY_DASHBOARD.label,
      mainPath: "/report-delivery",
    },
    {
      href: FRONTEND_ROUTES.BROKER_DELIVERY_SCHEDULES.route,
      icon: Clock,
      tooltip:
        FRONTEND_ROUTES.BROKER_DELIVERY_SCHEDULES.label,
      label:
        FRONTEND_ROUTES.BROKER_DELIVERY_SCHEDULES.label,
      mainPath: "/report-delivery/schedules",
    },
    {
      href: FRONTEND_ROUTES.BROKER_DELIVERY_PROCESS.route,
      icon: Play,
      tooltip:
        FRONTEND_ROUTES.BROKER_DELIVERY_PROCESS.label,
      label: FRONTEND_ROUTES.BROKER_DELIVERY_PROCESS.label,
      mainPath: "/report-delivery/process",
    },
    {
      href: FRONTEND_ROUTES.CHROMIUM.route,
      icon: MonitorCog,
      tooltip: FRONTEND_ROUTES.CHROMIUM.label,
      label: FRONTEND_ROUTES.CHROMIUM.label,
      mainPath: "/chromium",
    },
  ],
  sidebarConfigurationsLinks: [
    {
      href: FRONTEND_ROUTES.PAY2B_CREDENTIALS.route,
      icon: Key,
      tooltip: FRONTEND_ROUTES.PAY2B_CREDENTIALS.label,
      label: FRONTEND_ROUTES.PAY2B_CREDENTIALS.label,
      mainPath: "/pay2b-credentials",
    },
    {
      href: FRONTEND_ROUTES.DOMAIN_PREFERENCES.route,
      icon: Settings,
      tooltip: FRONTEND_ROUTES.DOMAIN_PREFERENCES.label,
      label: FRONTEND_ROUTES.DOMAIN_PREFERENCES.label,
      mainPath: "/domain-preferences",
    },
    {
      href: FRONTEND_ROUTES.BROKER_DELIVERY_TRANSFER_CONFIGS
        .route,
      icon: Server,
      tooltip:
        FRONTEND_ROUTES.BROKER_DELIVERY_TRANSFER_CONFIGS
          .label,
      label:
        FRONTEND_ROUTES.BROKER_DELIVERY_TRANSFER_CONFIGS
          .label,
      mainPath: "/report-delivery/transfer-configs",
    },
    {
      href: FRONTEND_ROUTES.WEBHOOKS.route,
      icon: Webhook,
      tooltip: FRONTEND_ROUTES.WEBHOOKS.label,
      label: FRONTEND_ROUTES.WEBHOOKS.label,
      mainPath: "/webhooks",
    },
    {
      href: FRONTEND_ROUTES.SSO_PROVIDERS.route,
      icon: Building,
      tooltip: FRONTEND_ROUTES.SSO_PROVIDERS.label,
      label: FRONTEND_ROUTES.SSO_PROVIDERS.label,
      mainPath: "/sso-providers",
    },
    {
      href: FRONTEND_ROUTES.SSO_HANDOFF_API_KEYS.route,
      icon: KeyRound,
      tooltip: FRONTEND_ROUTES.SSO_HANDOFF_API_KEYS.label,
      label: FRONTEND_ROUTES.SSO_HANDOFF_API_KEYS.label,
      mainPath: "/sso-handoff-api-keys",
    },
  ],
  logoutText: "Log out",
}
